import { CalendarViewType } from "../../types/account/enum";
import { useQueryClient } from "@tanstack/react-query";
import { userQueryKeys } from "../../react-query/user/queries";
import { ResponseUser } from "../../types/account/type";
import { usePreference } from "../preference/usePreference";
import { DefaultPreferenceOptions } from "../../constants/userPreference";

export const useCalendarViewType = () => {
  const { preference: userPreference, updatePreference } = usePreference();
  const currentViewType =
    userPreference?.calendarViewType ?? DefaultPreferenceOptions.calendarViewType;
  const queryClient = useQueryClient();

  const setCalendarViewType = (viewType: CalendarViewType) => {
    updatePreference({ calendarViewType: viewType });
  };

  //  NOTE: 이 함수는 recoil 상태를 업데이트만 하고, 서버에 업데이트하지 않음(모바일 1day view 용도)
  const setCalendarViewWithoutMutation = (viewType: CalendarViewType) => {
    queryClient.setQueryData(userQueryKeys.all, (prev: ResponseUser) => {
      if (!prev) return prev;
      return {
        ...prev,
        preference: { ...prev?.preference, calendarViewType: viewType },
      };
    });
  };

  return {
    currentViewType,
    setCalendarViewType,
    setCalendarViewWithoutMutation,
  };
};
